import { Reveal } from "@/components/Reveal";
import { AssessmentButton, GhostLink } from "@/components/Ctas";
import { CALENDLY_URL } from "@/config";

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="bg-ink py-24 text-paper sm:py-32 lg:py-40"
    >
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-amber">
            07 — Next Step
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2
            data-testid="final-cta-headline"
            className="mt-6 font-serif text-3xl font-light leading-[1.12] tracking-tight sm:text-4xl md:text-6xl"
          >
            Get Your Free Strategy &amp; Systems Assessment
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mx-auto mt-7 max-w-xl text-base leading-relaxed text-paper/70 sm:text-lg">
            Identify where you&apos;re losing clarity, capacity or momentum —
            and what to focus on next.
          </p>
        </Reveal>
        <Reveal delay={0.26}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-7">
            <AssessmentButton testid="final-cta-assessment" dark />
            <GhostLink
              testid="final-cta-book-call"
              href={CALENDLY_URL}
              dark
            >
              Book an Intro Call
            </GhostLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
